import React, { Component } from 'react';
import PauseIconMedium from '../../util/icons/components/PauseIconMedium';
import PlayIconLight from '../../util/icons/components/PlayIconLight';
import LoadingIcon from '../../util/icons/components/LoadingIcon';
import './beef-holding-page.scss';

/* eslint-disable max-len */

class BeefHoldingPage extends Component {
  constructor (props) {
    super(props);
    this.state = {
      playing: false
    };
    this.playPause = this.playPause.bind(this);
    this.videoRef = React.createRef();
  }

  playPause () {
    this.setState({ playing: !this.state.playing }, () => {
      if (this.state.playing) {
        this.videoRef.current.play();
      } else {
        this.videoRef.current.pause();
      }
    });
  }

  render () {
    const playClass =
    (this.state.playing !== true && this.state.loading !== true) ? 'show' : null;
    const pauseClass =
    (this.state.playing && this.state.hover && this.state.loading !== true)
      ? 'show' : null;
    const loadingClass = this.state.loading ? 'show' : 'hide';
    return (
      <div className="beef-holding-page bb-page-wrapper">
        <h1>{ 'We\'ll be launching a beef product soon...' }</h1>
        <div
          className='video-wrapper'
          onClick={this.playPause} >
          <div className='play-pause-buttons'>
            <PauseIconMedium className={pauseClass} />
            <PlayIconLight className={playClass} />
            <LoadingIcon className={loadingClass} />
          </div>
          <video
            loop=""
            muted=""
            ref={ this.videoRef}
            playsInline=""
            poster="https://media.beefbook.com/BeefBook_Drone_Clip/img/drone_poster_1080.jpg">
            <source
              type="application/x-mpegURL"
              src="https://media.beefbook.com/BeefBook_Drone_Clip/hls/master.m3u8"/>
            <source
              type="video/mp4"
              src="https://media.beefbook.com/BeefBook_Drone_Clip/mp4/BeefBook_Drone_Clip.mp4"/>
          </video>
        </div>
      </div>
    );
  }
}

export default BeefHoldingPage;
